/**
 * Simple script to check and log the number of products in the user's wishlist
 * Runs on page load and logs the wishlist count to console
 * Also updates count dynamically when products are added/removed
 */
let currentWishlistCount = 0;
function logWishlistCount() {
  // Check if Swym is available
  const swat = window.swat || window._swat;
  if (!swat) {
    return;
  }

  // Get the list ID using fetchLists
  swat.fetchLists({
    callbackFn: function (lists) {
      if (!lists || lists.length === 0) {
        currentWishlistCount = 0;

        // Dispatch event to update the display
        window.dispatchEvent(new CustomEvent('wishlist:count-updated', {
          detail: {
            count: currentWishlistCount
          }
        }));
        return;
      }

      // Get the first wishlist ID
      const wishlistId = lists[0].lid;

      // Fetch the actual contents using fetchListCtx
      const listConfig = {
        "lid": wishlistId
      };
      swat.fetchListCtx(listConfig, function (listContents) {
        var contents = Array.isArray(listContents) ? listContents : [];
        if (!contents.length) {
          currentWishlistCount = 0;
          window.dispatchEvent(new CustomEvent('wishlist:count-updated', {
            detail: {
              count: currentWishlistCount
            }
          }));
          return;
        }

        // Filter out unavailable products by checking their card endpoint response
        var checks = contents.map(function (item) {
          var url = item.du || '';
          try {
            var handle = url.split('/products/')[1].split('?')[0].replace(/\/$/, '');
            var viewUrl = '/products/' + handle + '?view=card';
            return fetch(viewUrl, {
              credentials: 'same-origin'
            }).then(function (res) {
              return res.ok;
            }).catch(function () {
              return false;
            });
          } catch (e) {
            return Promise.resolve(false);
          }
        });
        Promise.all(checks).then(function (results) {
          // Count only those with res.ok === true
          currentWishlistCount = results.reduce(function (acc, ok) {
            return acc + (ok ? 1 : 0);
          }, 0);
          window.dispatchEvent(new CustomEvent('wishlist:count-updated', {
            detail: {
              count: currentWishlistCount
            }
          }));
        }).catch(function () {
          currentWishlistCount = 0;
          window.dispatchEvent(new CustomEvent('wishlist:count-updated', {
            detail: {
              count: currentWishlistCount
            }
          }));
        });
      }, function (error) {
        currentWishlistCount = 0;
        window.dispatchEvent(new CustomEvent('wishlist:count-updated', {
          detail: {
            count: currentWishlistCount
          }
        }));
      });
    },
    errorFn: function (error) {
    }
  });
}
function updateWishlistCount() {
  // Re-fetch the wishlist to get the updated count
  logWishlistCount();
}

// Function to initialize the wishlist count check
function initWishlistCountCheck() {
  // Try to run immediately if Swym is already loaded
  if (window.swat || window._swat) {
    logWishlistCount();
  }

  // If Swym is not loaded, wait for it
  if (!window.SwymCallbacks) {
    window.SwymCallbacks = [];
  }

  // Add our callback to the Swym callbacks
  window.SwymCallbacks.push(function (swat) {
    logWishlistCount();
  });

  // Also listen for the swym:ready event as a fallback
  document.addEventListener('swym:ready', function () {
    logWishlistCount();
  }, {
    once: true
  });

  // Listen for wishlist changes from PDP and PLP
  window.addEventListener('wishlist:product-added', function (event) {
    // Add a small delay to ensure the wishlist has been updated on the server
    setTimeout(updateWishlistCount, 500);
  });
  window.addEventListener('wishlist:product-removed', function (event) {
    // Add a small delay to ensure the wishlist has been updated on the server
    setTimeout(updateWishlistCount, 500);
  });
}

// Custom element for wishlist count display
class WishlistCount extends HTMLElement {
  connectedCallback() {
    // Listen for wishlist count updates
    window.addEventListener('wishlist:count-updated', event => {
      const count = event.detail.count;
      this.innerText = count;

      // Show/hide based on count
      if (count > 0) {
        this.style.display = 'inline-flex';
      } else {
        this.style.display = 'none';
      }
    });

    // Set initial count and hide
    this.innerText = '0';
    this.style.display = 'none';
  }
}

// Register the custom element
if (!customElements.get('wishlist-count')) {
  customElements.define('wishlist-count', WishlistCount);
}

// Initialize when DOM is ready
if (document.readyState === 'loading') {
  document.addEventListener('DOMContentLoaded', initWishlistCountCheck);
} else {
  initWishlistCountCheck();
}
